module.exports = __webpack_public_path__ + "media/images/pages/ai/pocstock-ethical-ai-face-31@2x-84cc747183e9697ec61bece7152d20bc.png";